import React from 'react';
import { Input, Row, Col } from 'reactstrap';
import SystemLabel from '../../system/SystemLabel/SystemLabel';
import { labelHelper } from '../../helpers/labelHelper';


export class ArchiveFilterBar extends React.Component {
    handleInput = (e) => {
        const { filterFiles } = this.props;
        filterFiles(e.target.value);
    }
    render() {
        const { result } = this.props;
        return (<React.Fragment>
            <Row className="grid-item-wrapper">
                <Col style={{ paddingLeft: '0px' }}>
                    <p className="text-muted avoid-style-leak"><SystemLabel name="Matches" />: {result}</p>
                </Col>
                <Col>
                    <Input className="avoid-style-leak" onChange={this.handleInput} placeholder={labelHelper.getLabel("Filter")} />
                </Col>
            </Row>
        </React.Fragment>)
    }

}